import { Link, useNavigate } from "react-router-dom";
import { euro, specList } from "../api/shop";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product }) {
  const { add } = useCart();
  const navigate = useNavigate();
  const specs = specList(product.specs);
  const outOfStock = product.stock !== null && product.stock !== undefined && product.stock <= 0;

  const buy = () => {
    add(product, 1);
    navigate("/carrito");
  };

  return (
    <article className="card">
      <Link to={`/movil/${encodeURIComponent(product.sku)}`} className="card__media">
        <img src={product.image} alt={`${product.brand} ${product.title}`} loading="lazy" />
      </Link>

      <p className="eyebrow card__brand">{product.brand}</p>

      <Link to={`/movil/${encodeURIComponent(product.sku)}`} className="card__title">
        {product.title}
      </Link>

      {specs.length > 0 && (
        <div className="specs">
          {specs.slice(0, 3).map((spec) => (
            <span key={spec}>{spec}</span>
          ))}
        </div>
      )}

      <div className="card__foot">
        <span className="tag">
          {euro(product.price)}
          <span className="tag__cur">€</span>
        </span>

        <button className="card__cta" onClick={buy} disabled={outOfStock}>
          {outOfStock ? "Agotado" : "Comprar"}
        </button>
      </div>
    </article>
  );
}
